import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => {
  const isDark = theme.palette.mode === 'dark';

  return {
    label: {
      display: 'flex',
      justifyContent: 'space-between',
      height: '100%',
      maxHeight: 92,
      color: isDark ? theme.palette.text.secondary : theme.palette.text.primary,
    },

    rightLabel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      height: '100%',
    },

    rightTopLabel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },

    link: {
      zIndex: 1,
      background: `linear-gradient(98deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main} 100%)`,

      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },

    balance: {
      fontWeight: 500,
      display: 'inline-flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      columnGap: theme.spacing(1),
    },
  };
});
